<div [ngClass]="visible ? 'menu menu--open w-auto' : 'menu menu--close'">
  <!-- Header con logo -->
  <div class="menu-header" [ngClass]="!visible ? 'collapsed' : ''">
    @if (visible) {
      <div class="menu-logo-container">
        <img
          src="/assets/images/ecoembes.png"
          alt="Ecoembes Área Privada"
          class="menu-logo-header"
        />
        <p class="logo-tagline">
          {{ "menu.logo-tagline" | translate }}
        </p>
      </div>
    } @else {
      <img
        src="/assets/images/aleta.png"
        alt="Ecoembes Área Privada"
        class="menu-logo-header"
      />
    }

    <button
      class="menu-toggle"
      (click)="toggleMenu()"
      [attr.aria-label]="visible ? 'Contraer menú' : 'Expandir menú'"
    >
      <img
        src="/assets/icons/arrow-line-right-grey.svg"
        alt="Toggle menu"
        class="toggle-icon"
        [ngClass]="visible ? 'icon-rotated' : ''"
      />
    </button>
  </div>
  <!-- Contenedor scrollable con las listas de menú -->
  <div class="menu-content">
    <!-- Lista de menú WORKSPACE -->
    <div class="menu-workspace">
      <app-menu-list
        [menuItems]="itemsWorkSpace"
        [visible]="visible"
        (menuItemClick)="navigate($event)"
      ></app-menu-list>
    </div>

    <div class="menu-hub">
      <app-menu-list
        [menuItems]="itemsHub"
        [visible]="visible"
        (menuItemClick)="navigate($event)"
      ></app-menu-list>
    </div>
  </div>

  <!-- Footer Lista de menú HUB & HUB SUGGESTIONS-->
  <div class="menu-footer">
    <app-menu-list
      [menuItems]="itemsFooter"
      [visible]="visible"
      (menuItemClick)="navigate($event)"
    ></app-menu-list>
    <div class="user-info-container" #userInfoRef>
      <button
        class="user-info"
        (click)="toggleUserMenu()"
        [attr.aria-label]="'Abrir menú de usuario'"
      >
        <i class="pi pi-user text-muted-color"></i>
        @if (visible) {
          <div class="user-details menu-item-text">
            {{ "menu.user.title" | translate }}
          </div>
          <i
            class="pi pi-chevron-right user-arrow"
            [ngClass]="{ 'user-arrow--rotated': userMenuVisible }"
          ></i>
        }
      </button>
    </div>

    @if (visible) {
      <p-button
        class="hidden-btn contact-button"
        [label]="'sidebar.contact-us' | translate"
        [rounded]="true"
        severity="secondary"
        size="large"
        [fluid]="true"
        (onClick)="onClickContact()"
      ></p-button>
    }
  </div>

  <!-- Dropdown del usuario FUERA del contenedor del menú -->
  @if (userMenuVisible) {
    <div class="user-dropdown-overlay" (click)="closeUserMenu()">
      <div
        class="user-dropdown-panel"
        (click)="$event.stopPropagation()"
        [style]="{ top: overLayUserTop }"
      >
        <!-- Header del usuario -->
        <div class="user-dropdown-header">
          <div class="user-info-detailed">
            <p-avatar
              [label]="userFirstLetter()"
              size="large"
              shape="circle"
              [style]="{ 'background-color': '#1f2937', color: '#ffffff' }"
            />
            <div class="user-details-full">
              @if (loadingUserData()) {
                <p-skeleton
                  width="10rem"
                  height="1.5rem"
                  styleClass="mb-2"
                ></p-skeleton>
                <p-skeleton width="12rem" height="1rem"></p-skeleton>
              } @else {
                <h3 class="user-full-name">
                  {{ userData()?.CLEAN_NOMBRE_DS }}
                </h3>
                <p class="user-email-full" [title]="userData()?.EMAIL || ''">
                  {{ userData()?.EMAIL }}
                </p>
              }
            </div>
          </div>
        </div>

        <div class="user-additional-info">
          <p class="user-id">
            {{ "sidebar.user-management.user" | translate }}:
            @if (loadingUserData()) {
              <p-skeleton
                width="6rem"
                height="1rem"
                [style]="{ display: 'inline-block', marginBottom: '-3px' }"
              ></p-skeleton>
            } @else {
              {{ userData()?.NOMBRE_DS }}
            }
          </p>
          <p class="user-contact">
            {{ "sidebar.user-management.contact" | translate }}:
            @if (loadingKam()) {
              <p-skeleton
                width="8rem"
                height="1rem"
                [style]="{ display: 'inline-block', marginBottom: '-3px' }"
              ></p-skeleton>
            } @else {
              {{
                kam()?.NOMBRE_DS
                  ? kam()?.NOMBRE_DS
                  : ("user-help.positions.supporter" | translate)
              }}
            }
          </p>
        </div>

        <!-- Opciones del menú de usuario -->
        <app-menu-list
          [menuItems]="itemsUser"
          [visible]="visible"
          (menuItemClick)="navigate($event)"
        ></app-menu-list>

        <div class="logout">
          <button class="logout-button" (click)="logout()">
            <i class="pi pi-sign-out"></i>
            <span>{{ "sidebar.user-management.logout" | translate }}</span>
          </button>
        </div>
      </div>
    </div>
  }

  <app-account-management-dialog
    [(visible)]="accountManagementDialogVisible"
    [initialSelectedMenu]="initialSelectedMenu()"
  ></app-account-management-dialog>

  <app-duplicate-coordinated-card-dialog
    [(visible)]="duplicateCardDialogVisible"
  ></app-duplicate-coordinated-card-dialog>
</div>
